import { Priority, getPopupRegistration, openPopup } from 'app/PopupHolder';
import Confirm from 'app/components/Confirm';
import withProperty from 'app/components/withProperty';
import classNames from 'classnames';
import Modal from 'components/base/Modal';
import SVG from 'components/base/SVG';
import config from 'config';
import React, { PureComponent } from 'react';
import {
  ButtonToolbar,
  Col,
  PageHeader,
  Row,
  ToggleButton,
  ToggleButtonGroup,
} from 'react-bootstrap/lib';
import { ReactSVG } from 'react-svg';
import formatFullAddressObject from 'utils/address/formatAddress';
import CheckIcon from '../../../assets/images/check.svg';
import CircleExclamation from '../../../assets/images/circle-exclamation.svg';
import { formatDateShort, formatLocalTime } from '../../../utils/date/formatDate';
import formatDate from '../../../utils/date/formatDate';
import DonutChart from './donutChart';
import css from './style.scss';
import { AduTypes, chartColors, getAduTypeIcon, Messages } from './utils';
import { ADUReference } from "./reference";

const {
  constants: {
    API: { ADU_CALCULATOR_BASE_URL },
  },
} = config;

export class AduCalculator extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      types: [],
      sizes: [],
      qualities: [],
      aduDonutValues: [],
      selectedAdu: {
        type: '',
        size: 0,
        quality: '',
        hvac: false,
        laundry: false,
      },
      dynamicAduLabel: {
        type: '',
        size: 0,
        quality: '',
      },
      aduTotal: 0,
      ratePerSqFt: 0,
      aduChartLoading: false,
      showAduModal: false,
      showDisclaimerModal: false,
      isAduLoaded: false,
      showError: false,
      apiError: false,
      loader: false,
      showPreviousAduValues: false,
      prevSummary: {},
    };
    this.openDisclaimer = this.openDisclaimer.bind(this);
    this.closeAduModal  = this.closeAduModal.bind(this);
    this.resetAduForm   = this.resetAduForm.bind(this);
    this.closeDisclaimerModal = this.closeDisclaimerModal.bind(this);
    this.deepEqual = this.deepEqual.bind(this);
  }
  deepEqual(obj1, obj2) {
    if (obj1 === obj2) return true;
  
    if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
      return false;
    }
  
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
  
    if (keys1.length !== keys2.length) return false;
  
    for (let key of keys1) {
      if (!keys2.includes(key) || !this.deepEqual(obj1[key], obj2[key])) {
        return false;
      }
    }
  
    return true;
  }
  componentDidMount() {
    this.getAduCategories();
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.property.get('id') && !this.deepEqual(this.state.selectedAdu, prevState.selectedAdu) && !this.state.showPreviousAduValues && this.validateAduSelection()) {
      this.updateAduValues();
    }
    if (!this.state.isAduLoaded && window.location.pathname.includes('/adu')) {
      this.getAduCategories();
    }
  }
  getAduCategories() {
    if (ADUReference.data && ADUReference.data.length > 0) {
      console.log(`ADU Reference Data :: ${JSON.stringify(ADUReference.data)}`);
      const types = ADUReference.data.filter(itm => itm.ref_type === AduTypes.ADU_TYPE);
      const sizes = ADUReference.data.filter(itm => itm.ref_type === AduTypes.ADU_SIZE);
      const qualities = ADUReference.data.filter(itm => itm.ref_type === AduTypes.ADU_QUALITY);
      this.setState({ types: types.sort((a, b) => a.sort_order - b.sort_order) });
      this.setState({ sizes: sizes.sort((a, b) => a.sort_order - b.sort_order) });
      this.setState({ qualities: qualities.sort((a, b) => a.sort_order - b.sort_order) });
      this.fetchSavedFilterConfiguration();
      this.updateAnalytics({ type: 1, pageId: 'AduLandingPage' });
    }
    this.setState({ isAduLoaded: true });
  }
  openDisclaimer() {
    this.setState({ showDisclaimerModal: true });
  }
  fetchSavedFilterConfiguration() {
    const { profile, property, confirm } = this.props;

    fetch(`${ADU_CALCULATOR_BASE_URL}/get-existing-adu-calculation/${profile.id}/${property.get('id')?.toString()}`, {
      method: 'GET',
      headers: {
        'x-auth-token': window.appAuthToken,
      },
    })
      .then(response => response.json())
      .then((res) => {
        if (res && !res.Message) {
          throw new Error(Messages.SERVICE_DOWN);
        }
        if (res && res.AduType && res.AduSize && res.AduQuality) {
          const selectedAdu = {
            type: res.AduType,
            size: res.AduSize,
            quality: res.AduQuality,
            hvac: res.Includes && res.Includes.includes('hvac'),
            laundry: res.Includes && res.Includes.includes('laundry'),
          };
          const dynamicAduLabel = { ...selectedAdu, type: this.state.types.find(itm => itm.ref_value === res.AduType).ref_label };
          this.setState({ prevSummary: res, selectedAdu, dynamicAduLabel });
          //this.updateAduValues();
        } else {
          this.setState({ prevSummary: {} });
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        this.setState({ apiError: true, showError: true, loader: false });
        confirm({ cancelLabel: null, question: Messages.ALERT2 });
      });
  }
  validateAduSelection() {
    const { type, size, quality } = this.state.selectedAdu;
    if (type && size && quality) {
      return true;
    }
    return false;
  }
  updateAduValues() {
    this.setState({ aduChartLoading: true });
    const { profile, property, confirm } = this.props;
    const address = property.get('address');
    const { selectedAdu, prevSummary } = this.state;
    const aduPayload = {
      userId: profile.id,
      zipCode: address.get('zip'),
      propertyId: property.get('id').toString(),
      propertyAddress: address.get('streetAddress'),
      aduSize: Number(selectedAdu.size),
      aduType: selectedAdu.type,
      aduQuality: selectedAdu.quality,
      hvac: selectedAdu.hvac ? 'hvac' : '',
      laundry: selectedAdu.laundry ? 'laundry' : '',
    };
    fetch(`${ADU_CALCULATOR_BASE_URL}/post-to-blue-hammer`, {
      method: 'POST',
      body: JSON.stringify(aduPayload),
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': window.appAuthToken,
      },
    })
      .then(response => response.json())
      .then((data) => {
        if (data && data.projectSummary) {
          const chartData = data.projectSummary.map((chart, ind) => ({
            ...chart,
            name: chart.projectGroupName,
            value: chart.subTotal,
            fill: chartColors[ind],
          }));
          this.setState({ aduDonutValues: chartData, ratePerSqFt: data.ratePerSqFt, aduTotal: data.total, showPreviousAduValues: false });
          this.updateAnalytics({ type: 2, pageId: 'AduCalculateButton' });
          this.setState({ aduChartLoading: false });
        } else {
          throw new Error(Messages.SERVICE_DOWN);
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        this.setState({ apiError: true, showError: true, loader: false });
        this.setState({ aduChartLoading: false });
        if (prevSummary && prevSummary.Result && prevSummary.Result.projectSummary) {
          const chartData = prevSummary.Result.projectSummary.map((chart, ind) => ({
            ...chart,
            name: chart.projectGroupName,
            value: chart.subTotal,
            fill: chartColors[ind],
          }));
          const previousAduSelection = {
            type: prevSummary.AduType,
            size: prevSummary.AduSize,
            quality: prevSummary.AduQuality,
            hvac: prevSummary.Includes && prevSummary.Includes.includes('hvac'),
            laundry: prevSummary.Includes && prevSummary.Includes.includes('laundry'),
          };
          this.setState({ aduDonutValues: chartData, ratePerSqFt: prevSummary.Result.ratePerSqFt, selectedAdu: previousAduSelection, showPreviousAduValues: true, aduTotal: prevSummary.Result.total });
          confirm({ cancelLabel: null, question: Messages.ALERT1 });
        } else {
          this.resetAduForm();
          confirm({ cancelLabel: null, question: Messages.ALERT2 });
        }
      });
  }

  updateAnalytics({ type, pageId }) {
    const { profile, property } = this.props;
    const analyticsPayload = {
      userId: profile.id,
      propertyId: property.get('id')?.toString(),
      type,
    };
    if (type === 1) {
      analyticsPayload.pageId = pageId;
    } else if (type === 2) {
      analyticsPayload.buttonId = pageId;
    }
    fetch(`${ADU_CALCULATOR_BASE_URL}/save-adu-analytics`, {
      method: 'POST',
      body: JSON.stringify(analyticsPayload),
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': window.appAuthToken,
      },
    })
      .then((data) => {
        console.log(data, 'Analytics response');
      })
      .catch((error) => {
        console.error('Error:', error);
        this.setState({ apiError: true, showError: true, loader: false });
      });
  }
  closeDisclaimerModal() {
    this.setState({ showDisclaimerModal: false });
  }
  closeAduModal() {
    this.resetAduForm();
    this.props.closePopup();
  }
  resetAduForm() {
    this.setState({
      isAduLoaded: false,
      showAduModal: false,
      selectedAdu: {
        type: '',
        size: 0,
        quality: '',
        hvac: false,
        laundry: false,
      },
      dynamicAduLabel: {
        type: '',
        size: 0,
        quality: '',
      },
      aduTotal: 0,
      ratePerSqFt: 0,
    });
  }
  render() {
    const { property } = this.props;
    const { types, sizes, qualities, selectedAdu, aduDonutValues, dynamicAduLabel, ratePerSqFt, aduTotal, aduChartLoading } = this.state;
    const currentDate = new Date();
    const spinnerClass = classNames(css.spinner, { [css.hidden]: !aduChartLoading });
    return (
      <div>
        <Modal
          isOpen
          onClose={this.closeAduModal}
          isCloseButton
          background="#fff"
          uniqId="AduCalculator"
          width="1340px"
          padding="0"
          customCloseBtnCls={css.btnClose}
          className={css.aduCalculatorModal}
          caption={
            <div className={css.header}>
              <div>
                <div className={css.headerTitle}>ADU Calculator</div>
                <p className={css.clsSupTitle}>
                  {formatFullAddressObject(property.get('address'), true)}
                </p>
              </div>

              {this.validateAduSelection() && (
                <div className={css.clsCalc}>
                  <p>Last Calculated: {formatLocalTime(currentDate)}, {formatDate(currentDate)}</p>
                </div>
              )}
            </div>
          }
        >
          <div className={css.aduContainer}>
            <Row className={css.clsBodyRow}>
              <Col md={6} xs={12} className={css.clsBodyLft}>
                <p className={css.clsType}>Type*</p>
                <ul className={css.clsIconsList}>
                  {!!types.length &&
                    types.map((type) => {
                      const activeType =
                        type.ref_value === selectedAdu.type;
                      return (
                        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
                        <li
                          key={type.ref_value}
                          onClick={() =>
                            this.setState({
                              selectedAdu: {
                                ...selectedAdu,
                                type: type.ref_value,
                              },
                              dynamicAduLabel: {
                                ...dynamicAduLabel,
                                type: type.dynamic_label,
                              },
                              showPreviousAduValues: false,
                            })
                          }
                        >
                          <p className={css.aduTypeLabel}>{type.ref_label}</p>
                          <ReactSVG
                            src={getAduTypeIcon(type.ref_value)}
                            className={classNames(css.svgIcon, {
                              [css.iconActive]: activeType,
                            })}
                          />
                        </li>
                      );
                    })}
                </ul>

                {selectedAdu.type === 'attached' && (
                  <div className={css.clsInterBox}>
                    <p>
                      <span> Attached ADUs </span> are connected to the main
                      home. It could be an apartment built onto the back or side
                      of the house, for example.
                    </p>
                  </div>
                )}
                {selectedAdu.type === 'detached' && (
                  <div className={css.clsInterBox}>
                    <p>
                      <span> Detached ADUs </span> are structurally separate
                      from the main home. It could be a tiny house, a backyard
                      cottage, or a detached garage that’s been renovated.
                    </p>
                  </div>
                )}
                {selectedAdu.type === 'abovelivingarea' && (
                  <div className={css.clsInterBox}>
                    <p>
                      <span> Above Living Area ADU </span>
                      is accessible through a stairway inside or outside the
                      main home.
                    </p>
                  </div>
                )}
                {selectedAdu.type === 'abovegarage' && (
                  <div className={css.clsInterBox}>
                    <p>
                      <span> Above Garage ADU </span>
                      makes use of an attached or detached garage by adding a
                      second-story ADU above it. Or, build a new structure,
                      keeping vehicles on the main level and the ADU on the
                      second.
                    </p>
                  </div>
                )}
                {selectedAdu.type === 'garageconversion' && (
                  <div className={css.clsInterBox}>
                    <p>
                      <span> Garage Conversion ADU </span>
                      makes use of an attached or detached garage by converting
                      the space into a residence.
                    </p>
                  </div>
                )}
                <div className={css.clsBtnGrp}>
                  <p className={css.clsBtnTitle}>Square Footage*</p>

                  <ButtonToolbar>
                    <ToggleButtonGroup
                      type="radio"
                      name="options"
                      defaultValue={1}
                    >
                      {sizes.length > 0 && sizes.map((size) => {
                        const activeSize =
                          size.ref_value === selectedAdu.size;
                        return (
                          <ToggleButton
                            key={size.ref_value}
                            value={size.ref_value}
                            className={classNames(css.clsBtn, css.minW70, { [css.activeType]: activeSize })}
                            onClick={() =>
                              this.setState({
                                selectedAdu: {
                                  ...selectedAdu,
                                  size: size.ref_value,
                                },
                                dynamicAduLabel: {
                                  ...dynamicAduLabel,
                                  size: size.dynamic_label,
                                },
                                showPreviousAduValues: false,
                              })
                            }
                          >{size.ref_label}</ToggleButton>
                        );
                      },
                      )}
                    </ToggleButtonGroup>
                  </ButtonToolbar>
                </div>

                <div className={css.clsBtnGrp}>
                  <p className={css.clsBtnTitle}>Quality*</p>
                  <ButtonToolbar>
                    <ToggleButtonGroup
                      type="radio"
                      name="options"
                      defaultValue={1}
                    >
                      {qualities.length > 0 && qualities.map((quality) => {
                        const activeQuality =
                          quality.ref_value === selectedAdu.quality;
                        return (
                          <ToggleButton
                            key={quality.ref_value}
                            value={quality.ref_value}
                            className={classNames(css.clsBtn, css.minW95, { [css.activeType]: activeQuality })}
                            onClick={() =>
                              this.setState({
                                selectedAdu: {
                                  ...selectedAdu,
                                  quality: quality.ref_value,
                                },
                                dynamicAduLabel: {
                                  ...dynamicAduLabel,
                                  quality: quality.dynamic_label,
                                },
                                showPreviousAduValues: false,
                              })
                            }
                          >{quality.ref_label}</ToggleButton>
                        );
                      },
                      )}
                    </ToggleButtonGroup>
                  </ButtonToolbar>
                </div>

                <div className={css.clsBtnGrp}>
                  <p className={css.clsBtnTitle}> Optional Additional Features</p>
                  <ButtonToolbar>
                    <ToggleButtonGroup type="checkbox" defaultValue={[1]}>
                      <ToggleButton
                        value={selectedAdu.hvac}
                        className={classNames(css.clsBtn, css.minW100, { [css.activeType]: selectedAdu.hvac })}
                        onChange={(e) => {
                          e.preventDefault();
                          this.setState({
                            selectedAdu: {
                              ...selectedAdu,
                              hvac: !selectedAdu.hvac,
                            },
                            showPreviousAduValues: false,
                          });
                        }
                        }
                      >
                        <span className={css.clsBtnCheck}>
                          <ReactSVG src={CheckIcon} className={css.svgIcon} />
                        </span>
                        HVAC
                      </ToggleButton>
                      <ToggleButton
                        value={selectedAdu.laundry}
                        className={classNames(css.clsBtn, css.minW100, { [css.activeType]: selectedAdu.laundry })}
                        onChange={(e) => {
                          e.preventDefault();
                          this.setState((prevState) => {
                            const updatedAdu = { ...prevState.selectedAdu };
                            updatedAdu.laundry = !updatedAdu.laundry;
                            return { selectedAdu: updatedAdu, showPreviousAduValues: false };
                          });
                        }
                        }
                      >
                        <span className={css.clsBtnCheck}>
                          <ReactSVG src={CheckIcon} className={css.svgIcon} />
                        </span>
                        Laundry
                      </ToggleButton>
                    </ToggleButtonGroup>
                  </ButtonToolbar>
                </div>
              </Col>
              {!this.validateAduSelection() ? (
                <Col md={6} lg={6} className={css.clsBodyRight}>
                  <div className={css.overview}>
                    <PageHeader className={css.overviewHeading}>
                      Results Are Available After Required Fields Are Selected
                    </PageHeader>
                    <div className={css.note}>
                      <h4>
                        <ReactSVG
                          src={CircleExclamation}
                          className={css.svgIcon}
                        />
                        Please Note
                      </h4>
                      <p>
                        Use this calculator to estimate the cost of creating an
                        ADU by zip code. Before starting renovations, please
                        ensure i) the property can support an ADU ii) you have the
                        required permits, and iii) you seek appropriate legal,
                        financial, construction, and/or other real estate
                        professional advice.
                      </p>
                      <p>
                        By using this calculator, you agree
                        to our <a onClick={this.openDisclaimer}>Disclaimer</a>.
                      </p>
                    </div>
                  </div>
                </Col>
              ) : (<Col md={6} lg={6} className={css.clsBodyRight}>
                <div className={classNames(css.overview, css.clsChartOverview)}>
                  {aduChartLoading ? <div className={spinnerClass}>
                    <SVG icon="spinner" />
                  </div> :
                  <DonutChart data={aduDonutValues} dynamicAduLabel={dynamicAduLabel} ratePerSqFt={ratePerSqFt} aduTotal={aduTotal} {...this.props} />
                  }
                </div>
              </Col>

              )}
            </Row>
          </div>
        </Modal>

        <Modal
          isOpen={this.state.showDisclaimerModal}
          uniqId="alert"
          padding="25px 10px"
          caption={
            <div className={css.header}>Copyright © 2023 Bluebook International - All Rights Reserved</div>
          }
          maxWidth="95%"
          maxHeight="95%"
          width="1200px"
          isCloseButton
          className={css.disclaimerModal}
          onClose={this.closeDisclaimerModal}
        >
          <div className={css.body}>
            DISCLAIMER: This report is subject to Bluebook's and/or the provider of this report's (collectively the "Company") Terms & Conditions, Users License, Privacy Policy, and any applicable contract terms. All information, however derived, entered or implemented including all data contained herein, is the sole property of the Company and its third party providers. This report (including graphs, charts, and photos) is derived from the use of proprietary automated valuation technologies, modeling, public record data, other data, your inputs, and proprietary predictive technologies. Your use constitutes a license. This report and the data contained in it may not be re-sold, remarketed, syndicated, compiled, or published without prior written permission from Company. This report does NOT constitute an appraisal, contractor's estimate/bid, or similar valuation. Inputs may not include visual inspections, neighborhood characteristics, demographics, topography, disaster surge pricing, and other factors that may influence values. Company does not offer tax advice, accounting advice, or contractor estimates. You should consult with appropriate financial, legal, construction, and/or real estate professionals before acting on or utilizing the report. THIS REPORT IS AN OPINION THAT MAY BE INACCURATE AND IS PROVIDED SOLELY AS AN INFORMATIONAL TOOL NOT DESIGNED TO PROVIDE DEFINITIVE ANSWERS. ALL ELEMENTS ARE OFFERED "AS IS" AND COMPANY EXPRESSLY DISCLAIMS ANY AND ALL WARRANTIES, REPRESENTATIONS, AND GUARANTEES OF ANY NATURE, EXPRESS, IMPLIED OR OTHERWISE, INCLUDING BUT NOT LIMITED TO ANY IMPLIED WARRANTIES OF MERCHANTABLITILY, NONINFRINGEMENT, TITLE, QUIET ENJOYMENT, ACCURACY, OR FITNESS FOR A PARTICULAR PURPOSE. IN NO EVENT SHALL COMPANY (OR ITS SUPPLIERS) BE LIABLE FOR ANY GENERAL, DIRECT, SPECIAL, INCIDENTAL, INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER (INCLUDING WITHOUT LIMITATION, THOSE RESULTING FROM USE OF THE PRODUCT, INCLUDING : (1) RELIANCE ON THE MATERIALS PRESENTED, (2) COSTS OF REPLACEMENT GOODS, (3) LOSS OF USE, DATA OR PROFITS, (4) DELAYS OR BUSINESS INTERRUPTIONS, (5) AND ANY THEORY OF LIABILITY, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF INFORMATION) WHETHER OR NOT COMPANY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
          </div>
        </Modal>
      </div>
    );
  }
}

const AduCalculatorPopup = withProperty((AduCalculator), state => ({}), {
  confirm: Confirm.open,
  alert: Confirm.alert,
});

const registrationId = getPopupRegistration(AduCalculatorPopup);

AduCalculatorPopup.open = props => openPopup(registrationId, { priority: Priority.HIGH, ...props });

export default AduCalculatorPopup;
